// src/components/Shared/ConsoleModal.jsx
import React, { useRef, useEffect } from 'react';
import ProcessStatusDisplay from './ProcessStatusDisplay'; // Changed from EmbeddedConsole

const ConsoleModal = ({
    title = "Console Output",
    lines = [],
    isLoading = false,
    status = "Idle",
    statusColor = "text-gray-400",
    actions = [],
    onClose,
    maxWidth = 'max-w-3xl',
    error,
    isConsoleInputEnabled = false,
    onSendCommand,
    // consolePlaceholderText is not directly used by ProcessStatusDisplay, but can be managed by lines logic
    consoleMaxHeight = "max-h-[calc(70vh-236px)] sm:max-h-[calc(80vh-236px)]", // Adjusted for increased padding: 220px + 16px (for p-6 vs p-4)
}) => {
    // consoleEndRef is managed by ProcessStatusDisplay internally

    // getTerminalLineClass is managed by ProcessStatusDisplay internally

    return (
        <div className={`flex flex-col h-[70vh] sm:h-[80vh] ${maxWidth} bg-dark-700 rounded-lg overflow-hidden`}> {/* Apply bg and rounded here if ProcessStatusDisplay showMainBorder=false */}
            {/* Modal-level close button, distinct from ProcessStatusDisplay's actions */}
            <div className="flex justify-end p-2_5 absolute top-3 right-3 z-10"> {/* Adjusted padding for better positioning */}
                <button onClick={onClose} className="text-gray-400 hover:text-white transition transform hover:scale-110">
                    <i className="fas fa-times fa-lg"></i>
                </button>
            </div>

            {/* Error Display Area - kept separate from ProcessStatusDisplay */}
            {error && (
                <div className="m-4 mb-0 p-3 bg-red-900/30 border border-accent-red/50 rounded-lg text-accent-red text-sm">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    <strong>Error:</strong> {error}
                </div>
            )}

            {/* Use ProcessStatusDisplay for the main console area */}
            <div className={`flex-grow p-6 ${error ? 'pt-4' : 'pt-6'}`}> {/* Increased padding: p-6, and if error pt-4 (was p-4, error pt-2) */}
                <ProcessStatusDisplay
                    lines={lines}
                    status={status}
                    statusColor={statusColor}
                    isLoading={isLoading} // Pass isLoading for status dot and disabling actions/input
                    // progressData={null} // No progress bar for this use case
                    actions={actions}
                    isConsoleInputEnabled={isConsoleInputEnabled}
                    onSendCommand={onSendCommand}
                    consoleTitle={title} // Pass the modal title to ProcessStatusDisplay's header
                    consoleMaxHeight={consoleMaxHeight} // Pass the max-h-[...] string
                    className="h-full" // Ensure ProcessStatusDisplay fills its container
                    showHeader={true}    // Use ProcessStatusDisplay's header
                    showProgressBar={false} // Disable progress bar
                    showActions={true}   // Use ProcessStatusDisplay's action rendering
                    showMainBorder={false} // Avoid double borders as ConsoleModal provides the "frame"
                />
            </div>
            {/* Global loading indicator can be removed if ProcessStatusDisplay's isLoading handling is sufficient */}
        </div>
    );
};

export default ConsoleModal;